import { Observable } from 'rxjs';

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class UserType {
  abstract getUserTypesByPagination(page: number, pageSize: number): Observable<ApiResponse>;
  abstract updateUserType(userData: any): Observable<ApiResponse>;
  abstract addUserType(userTypeData: any): Observable<ApiResponse>;
}
